import { FC } from 'react';

import RouterLink from 'app/components/shared/RouterLink';
import { BoxProps } from 'app/components/v2/components/Box';
import Flex from 'app/components/v2/components/Flex';
import Text from 'app/components/v2/components/Text';

// Local Typings
export interface Crumb {
  href?: string;
  label: string;
  onClick?: () => void;
  to?: string;
}
export interface BreadcrumbsProps {
  crumbs: Crumb[];
}

// Component Definition
const Breadcrumbs: FC<BoxProps & BreadcrumbsProps> = ({
  crumbs,
  ...boxProps
}) => {
  return (
    <Flex
      alignItems="initial" // fixes vertical alignment issue
      as="ul"
      display="inline-flex"
      flexWrap="wrap"
      paddingY={1}
      {...boxProps}
    >
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;

        return (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`${crumb.label}-${index}`}>
            {isLast
              ? (
                <Text
                  fontSize="smallBody"
                  noWrap
                >
                  {crumb.label}
                </Text>
              )
              : (
                <>
                  <RouterLink
                    disabled={isLast}
                    fontSize="smallBody"
                    href={crumb.href}
                    noWrap
                    onClick={crumb.onClick}
                    to={crumb.to}
                  >
                    {crumb.label}
                  </RouterLink>

                  <Text
                    as="span"
                    fontSize="smallBody"
                    marginX={2}
                    noWrap
                  >
                    /
                  </Text>
                </>
              )}
          </li>
        );
      })}
    </Flex>
  );
};

export default Breadcrumbs;
